import menuModalTpl from './base';

export { menuModalTpl }